import MLS from 'assets/images/mls.svg';
import PreForeClosure from 'assets/images/pre-foreclosures.svg';
import Auction from 'assets/images/auction.svg';
import BankOwned from 'assets/images/bank-owned.svg';
import CashBuyer from 'assets/images/cash-buyer.svg';
import Liens from 'assets/images/liens.svg';
import Vacant from 'assets/images/vacant.svg';
import HighEquity from 'assets/images/high-equity.svg';
import Bankruptcy from 'assets/images/bankcurrpcy.svg';
import HasLien from 'assets/images/liens-svg.svg';
import FreeClear from 'assets/images/free-clear.svg';
import NegEquity from 'assets/images/neg-equity.svg';
import LowEquity from 'assets/images/low-equity.svg';
import OnMarket from 'assets/images/on-market.svg';
import Total from 'assets/images/total-properties.svg';
import JustSold from 'assets/images/just-sold.svg';
import Divorce from 'assets/images/divorce.svg';
import FailedListings from 'assets/images/failedListings.svg';
import Flippers from 'assets/images/flippers.svg';
import SeniorOwners from 'assets/images/senior-owners.svg';
import PreProbate from 'assets/images/pre-probate.svg';
import TaxDelinquency from 'assets/images/tax-delinquency.svg';
import TiredLandlords from 'assets/images/tired-landlords.svg';
import UpsideDown from 'assets/images/upside-down.svg';
import VacantLand from 'assets/images/vacant-land.svg';
import ZombieProperties from 'assets/images/zombie-properties.svg';
import AssumableMtg from 'assets/images/Lead-List-Icons.svg';
import CustomIcon from 'assets/images/custom-list.svg';
import Additions from 'assets/images/additions.svg';
import Removals from 'assets/images/removals.svg';

export const getSearchPanelIcons = (label) => {
  switch (label) {
    case 'MLS':
      return MLS;
    case 'Pre-Foreclosures':
    case 'Pre-Foreclosure':
      return PreForeClosure;
    case 'Auctions':
    case 'Auction':
      return Auction;
    case 'Bank Owned':
      return BankOwned;
    case 'Assumable Mtg.':
      return AssumableMtg;
    case 'Bankruptcy':
      return Bankruptcy;
    case 'Cash Buyers':
      return CashBuyer;
    case 'Liens':
      return Liens;
    case 'Vacant':
      return Vacant;
    case 'Vacant Land':
      return VacantLand;
    case 'High Equity':
      return HighEquity;
    case 'Has Lien':
      return HasLien;
    case 'Free & Clear':
      return FreeClear;
    case 'Neg Equity':
      return NegEquity;
    case 'Low Equity':
      return LowEquity;
    case 'On Market':
      return OnMarket;
    case 'Additions':
      return Additions;
    case 'Removals':
      return Removals;
    case 'Just Sold':
      return JustSold;
    case 'Total':
    case 'All Properties':
      return Total;
    case 'Divorce':
      return Divorce;
    case 'Failed Listings':
      return FailedListings;
    case 'Flippers':
      return Flippers;
    case 'Senior Owners':
      return SeniorOwners;
    case 'Pre-Probate (Deceased Owners)':
    case 'Pre-Probate':
      return PreProbate;
    case 'Tax Delinquencies':
    case 'Tax Delinquency':
      return TaxDelinquency;
    case 'Tired Landlords':
      return TiredLandlords;
    case 'Upside Down':
      return UpsideDown;
    case 'Zombie Properties':
      return ZombieProperties;
    case 'Assumable Mtg.':
    case 'Assumable Mortgages':
      return AssumableMtg;
    case 'Loading':
      return '';
    default:
      return CustomIcon;
  }
};
